import React from "react";
import CurveUp from "./CurveUp";
import CurveDown from "./CurveDown";
import ShearUp from "./ShearUp";
import ShearDown from "./ShearDown";

const Icons = ({ transformType, handleUpdateTransformType }) => {
  const handleClick = (transformType) => {
    handleUpdateTransformType(transformType);
  };

  return (
    <ul className="transform-icons">
      <ShearUp
        transformType={transformType}
        onHandleTransformType={() => handleClick("shear_up")}
      />
      <ShearDown
        transformType={transformType}
        onHandleTransformType={() => handleClick("shear_down")}
      />
      <CurveUp
        transformType={transformType}
        onHandleTransformType={() => handleClick("curve_up")}
      />
      <CurveDown
        transformType={transformType}
        onHandleTransformType={() => handleClick("curve_down")}
      />
    </ul>
  );
};

export default Icons;
